<template>
	<ul id="bk-list" class="bk-list clearfix">
		<Book v-for="Book in Books" :key="Book.ISBN" :Data='Book'></Book>
	</ul>
</template>

<script>
	const firebase = require('firebase');
	import Book from '@/components/Book.vue';

	export default {
		name: 'Bookshelf',
		components: {	Book },
		created(){
			firebase.database().ref('/BookItem').once('value').then((snapshot) => {
				this.Books = snapshot.val();
			});
		},
		data() {
			return {
				Books: [],
			}
		},
	}
</script>

<style scoped>
	*,
	*:after,
	*:before {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		padding: 0;
		margin: 0;
	}

	/* Clearfix hack by Nicolas Gallagher: http://nicolasgallagher.com/micro-clearfix-hack/ */
	.clearfix:before,
	.clearfix:after {
			content: " ";
			display: table;
	}

	.clearfix:after {
			clear: both;
	}

	.clearfix {
			*zoom: 1;
	}

	/* Header Style */
	.codrops-top {
		line-height: 24px;
		font-size: 11px;
		background: #fff;
		background: rgba(255, 255, 255, 0.5);
		text-transform: uppercase;
		z-index: 9999;
		position: relative;
		box-shadow: 1px 0px 2px rgba(0,0,0,0.2);
	}

	.codrops-top a {
		padding: 0px 10px;
		letter-spacing: 1px;
		color: #333;
		display: inline-block;
	}

	.codrops-top a:hover {
		background: rgba(255,255,255,0.8);
		color: #000;
	}

	.codrops-top span.right {
		float: right;
	}

	.codrops-top span.right a {
		float: left;
		display: block;
	}

	/* Demo Buttons Style */
	.codrops-demos {
		float: right;
	}

	.codrops-demos a {
			display: inline-block;
			margin: 10px;
			color: #666;
			font-weight: 700;
			line-height: 30px;
			border-bottom: 4px solid transparent;
	}

	.codrops-demos a:hover {
		color: #000;
		border-color: #000;
	}

	.codrops-demos a.current-demo,
	.codrops-demos a.current-demo:hover {
		color: #aaa;
		border-color: #aaa;
	}

	.bk-list {
		margin: 1em;
		list-style: none;
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: center;
		flex-wrap: wrap;
	}
</style>
